export default {
  // Config
  apiKey: "AIzaSyBmvRmvYKD1O8TP6VFwYO3qkHpZWEmFbH0",
  authDomain: "yumaway-mytrace.firebaseapp.com",
  projectId: "yumaway-mytrace",
  storageBucket: "yumaway-mytrace.firebasestorage.app",
  messagingSenderId: "694928168402",
  appId: "1:694928168402:web:b3fe45c5761a3eda26640b"
};
